import { render, staticRenderFns } from "./statusChangeSelfCapable.vue?vue&type=template&id=661db27c&"
import script from "./statusChangeSelfCapable.vue?vue&type=script&lang=js&"
export * from "./statusChangeSelfCapable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports